import {
  V1CreateWithdrawalSummaryResponse,
  V1RetirementDistributionType,
} from '@fintronners/react-api/src';

export const getDistributionTypeFromWithdrawalSummary = (
  withdrawalSummary: V1CreateWithdrawalSummaryResponse | undefined,
): V1RetirementDistributionType => {
  const availableTypes = withdrawalSummary?.retirement?.distributionConstraints?.validTypes || [];

  return availableTypes.some(({ type }) => type === V1RetirementDistributionType.Premature)
    ? V1RetirementDistributionType.Premature
    : V1RetirementDistributionType.Normal;
};
